import React, { useContext } from "react";
import { ErrorContext } from "./ErrorStore";
import { ClearErrorAction, ErrorActionType } from "./ErrorReducer";
import DialogCookieCleaner from "@utdanningsdirektoratet/udir-common/lib/components/cookieCleaner/DialogCookieCleaner";
import { GeneralExceptionResponse, ValidationExceptionResponse } from "../../../elev/generated/types/error";
import { Modal, Container } from "@utdanningsdirektoratet/lisa";
import { P } from "../components/p";

export const ErrorDialog: React.FunctionComponent = () => {
	const { state, dispatch } = useContext(ErrorContext);

	if (!state.error) {
		return null;
	}

	const title = getErrorHeader(state.error.statusCode);

	return (
		<Modal
			title={title}
			showModal={true}
			maxWidth="640px"
			onCancel={() => {
				clearErrors(dispatch);
			}}
			id="error-modal"
		>
			<div className="mb-32 mt-16">{getErrorBody(state.error)}</div>
			<DialogCookieCleaner
				onCookieClean={() => (window.location.href = "/")}
				cleanLinkLabel={"Start økten på nytt"}
				expandedContent={
					<Container className="mb-16">
						<P>
							Dersom denne feilmeldingen kommer gjentatte ganger over lengre tid, kan du forsøke å starte økten på nytt
							ved å følge lenken nedenfor, prøve igjen senere, eller kontakte brukerstøtte.
						</P>
						<P>Brukerstøtte går tjenestevei.</P>
					</Container>
				}
			/>
		</Modal>
	);
};

const defaultTitle = "Vi beklager";

const getErrorHeader = (statusCode: number | null): string => {
	switch (statusCode) {
		case 500:
			return "Du kan dessverre ikke benytte deg av denne tjenesten akkurat nå";
		case 403:
			return "Ingen tilgang";
		case 400:
			return "Det har skjedd en feil ved forespørselen";
		default:
			return defaultTitle;
	}
};

const getErrorBody = (error: GeneralExceptionResponse | ValidationExceptionResponse): JSX.Element => {
	switch (error.statusCode) {
		case 500:
			return (
				<>
					<P>Dette skyldes en intern feil hos Utdanningsdirektoratet. </P>
					<P>Du kan forsøke igjen senere, eller kontakte brukerstøtte.</P>
				</>
			);
		case 403:
			return error?.message ? (
				<P>{error.message}</P>
			) : (
				<div>
					<P>Det kan være flere årsaker til dette, for eksempel:</P>
					<ul className="bullets">
						<li>Du er ikke logget inn.</li>
						<li>
							Du har flere brukerroller i Utdanningsdirektoratets tjeneste for eksamensadministrasjon , og er ikke
							logget inn med riktig brukerrolle.
						</li>
						<li>Du har ikke tilgang til siden du forsøker å se</li>
					</ul>
					<P>Brukerstøtte går tjenestevei.</P>
				</div>
			);
		case 400:
			return error?.message ? <P>{error.message}</P> : <P>Ugyldig forespørsel</P>;
		default:
			return <P>{error?.message ?? "Noe gikk galt"}</P>;
	}
};

const clearErrors = (dispatch: React.Dispatch<ErrorActionType>) => {
	dispatch(ClearErrorAction());
};
